import { render, staticRenderFns } from "./ns-checkbox.vue?vue&type=template&id=1b9c0181&scoped=true&"
import script from "./ns-checkbox.vue?vue&type=script&lang=js&"
export * from "./ns-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./ns-checkbox.vue?vue&type=style&index=0&id=1b9c0181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c0181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9c0181')) {
      api.createRecord('1b9c0181', component.options)
    } else {
      api.reload('1b9c0181', component.options)
    }
    module.hot.accept("./ns-checkbox.vue?vue&type=template&id=1b9c0181&scoped=true&", function () {
      api.rerender('1b9c0181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/loyalty-elements/src/common/ns-checkbox.vue"
export default component.exports